import { render } from "./IntegrationMetaItem.vue?vue&type=template&id=332c82b0&scoped=true"
import script from "./IntegrationMetaItem.vue?vue&type=script&lang=js"
export * from "./IntegrationMetaItem.vue?vue&type=script&lang=js"

import "./IntegrationMetaItem.vue?vue&type=style&index=0&id=332c82b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332c82b0"]])

export default __exports__